import { render, staticRenderFns } from "./StripeBridgeSync.vue?vue&type=template&id=080be0fa&scoped=true"
import script from "./StripeBridgeSync.vue?vue&type=script&lang=js"
export * from "./StripeBridgeSync.vue?vue&type=script&lang=js"
import style0 from "./StripeBridgeSync.vue?vue&type=style&index=0&id=080be0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080be0fa",
  null
  
)

export default component.exports